/* eslint-disable max-len */
import { CSSProperties, useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { Col, Row } from "../../components/StyledGridSystem";
import { StyledText, TextSize } from "../../components/Text";
import StyledTable from "../../components/StyledTable";
import StyledEvent from "../../components/StyledEvent";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import generateCalendar, {
  generateDates,
  generateHeaderwidth,
  generateOptionalCalendar,
  generateSampleTimeLineDates,
} from "../../hooks/generateCalendar";
import { useNavigate } from "react-router-dom";
import { SemesterContext } from "../../context/SemesterContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { StyledAddButton } from "./RoadMap";
import Icon from "../../components/Icon";
import ViewSelect from "../../components/ViewSelect";
import moment from "moment";
import SnackBar from "../../components/SnackBar";
import { truncateSync } from "fs";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import { UniversityContext } from "../../context/UniversityContext";

const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;

export const CustomFlex = styled(FlexBox) <{
  $sidebarOpen: boolean;
  $isMobile: boolean;
}>`
  left: ${({ $sidebarOpen, $isMobile }) =>
    $sidebarOpen ? "455px" : $isMobile ? "212px" : "275px"};
  z-index: 1000;
  position: fixed;
  top: ${({ $isMobile }) => ($isMobile ? "15px" : "0px")};
  height: ${({ $isMobile }) => ($isMobile ? "60px" : "74px")};
  width: ${({ $isMobile }) => ($isMobile ? "110px" : "auto")};
  *:not(:last-child) {
    margin-right: ${({ $isMobile }) => ($isMobile ? "4px" : "8px")};
  }
`;
const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.33);
  padding: 7px 12px;
  height: 36px;
  border: 1px solid #e7ebee;
  box-sizing: border-box;
  backdrop-filter: blur(33px);
  border-radius: 6px;
  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.33);
  }
`;
const ActiveButton: CSSProperties | undefined = {
  background: "rgb(167 54 56)",
  border: "1px solid #808080",
  padding: "7px 10px",
  height: "36px",
  boxSizing: "border-box",
  backdropFilter: "blur(33px)",
  borderRadius: "6px",
};
const NormalButton: CSSProperties | undefined = {
  background: "rgb(57 72 96)",
  border: "1px solid #808080",
  padding: "7px 10px",
  height: "36px",
  boxSizing: "border-box",
  backdropFilter: "blur(33px)",
  borderRadius: "6px",
};
function RoadMapTimelinePage() {
  const screenClass = useScreenClass();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [dates, setDates] = useState<Array<any>>([]);
  const [requiredEvents, setRequiredEvents] = useState<Array<any>>([]);
  const [optionalEvents, setOptionalEvents] = useState<Array<any>>([]);
  const [roadmapId, setRoadmapId] = useState<string>();
  const [requiredWidth, setRequiredWidth] = useState<string>("");
  const [optionalWidth, setOptionalWidth] = useState<string>("");
  const [currentView, setCurrentView] = useState<"week" | "month">("month");
  const currentUser = useContext(UserContext).user;
  const userContext = useContext(UserContext);
  const universityContext = useContext(UniversityContext);
  const semesterContext = useContext(SemesterContext);
  const [credits, setCredits] = useState("");
  const [requiredCredits, setRequiredCredits] = useState(0);
  const [optionalCredits, setOptionalCredits] = useState(0);
  const [enrolled, setEnrolled] = useState<boolean>(false);
  const [isRemindOpen, setIsRemindOpen] = useState<boolean>(false);

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const isLarge = useMemo(() => ["xxl"].includes(screenClass), [screenClass]);
  useEffect(() => {
    fetchVersion(currentUser?.id);
    fetchRecommended();
  }, [currentUser, semesterContext, userContext]);
  const fetchVersion = (id: string) => {
    setEnrolled(true);
    if(semesterContext.selectedSemester.label)
    axios
      .get(
        `/student/version?student_id=${id}&semester_name=${semesterContext.selectedSemester.label}&program_id=${userContext.user?.programs?.[0]?.id}`
      )
      .then((res) => { })
      .catch((error) => {
        if (
          error.response.data.error === "Student not enrolled for this semester"
        ) {
          setEnrolled(false);
        } else {
          console.log("An error occurred:", error);
        }
      });
  };
  const fetchAnouncement = async () => {
    try {
      const res = await axios.get(
        `/announcement/remind?email=${userContext.user.email}`
      );

      if (res.data.isRemind === true) {
        const announcementShown = localStorage.getItem("announcementShown");
        if (!announcementShown) {
          setIsRemindOpen(true);

          localStorage.setItem("announcementShown", "true");
        }
      } else {
        // console.log("Announcement:", res);
      }
    } catch (error) {
      console.error("Error fetching announcement:", error);
    }
  };

  useEffect(() => {
    fetchAnouncement();
  }, []);

  const redirectRoadmap = () => {
    userContext.setCurrentRoadmapView({
      name: "quest",
      url: "/roadmap",
    });
    navigate("/roadmap");
  };
  const fetchRecommended = () => {
    setLoading(true);
    if(!semesterContext.selectedSemester.label && !userContext.user?.programs?.[0]?.program_name || !universityContext.selectedProgram?.short_name )
    {
      return;
    }
    axios
      .get(
        `/roadmap/milestones?student_id=${currentUser.id}&year=${semesterContext.selectedSemester.year}&semester=${semesterContext.selectedSemester.label}&program_name=${userContext.user?.programs?.[0]?.program_name || universityContext.selectedProgram?.short_name}`
      )
      .then((res) => {
        const customArray: any[] = [];
        if (res.data.roadmaps) {
          var requiredCount = 0;
          var optionalCount = 0;

          res.data.roadmaps.forEach((roadmap: any) => {
            roadmap.milestones.forEach((milestone: any) => {
              if (milestone.competency_card?.status === 'Incomplete') return;
              if (milestone.required) {
                requiredCount =
                  requiredCount + milestone.competency_card.credits;
              } else if (!milestone.required) {
                optionalCount =
                  optionalCount + milestone.competency_card.credits;
              }
            });
            setRoadmapId(roadmap.id);
            setCredits(roadmap.credits);
            setRequiredCredits(requiredCount);
            setOptionalCredits(optionalCount);
            roadmap.milestones.forEach((group: any) => {
              if (group.competency_card?.status !== 'Incomplete') {
                customArray.push(group);
              }
            });
          });
        }
        else if (!res.data.roadmaps) {
          setCredits("0");
          setRequiredCredits(0);
          setOptionalCredits(0);
        }
        // const earliest = semesterContext.selectedSemester.start_date;
        // const latest = semesterContext.selectedSemester.end_date;
        const earliest = moment(semesterContext.selectedSemester.start_date)
          .startOf("month")
          .format("YYYY-MM-DD");
        const latest = moment(semesterContext.selectedSemester.end_date)
          .endOf("month")
          .format("YYYY-MM-DD");
        const requiredLength = customArray.filter(
          (el: any) => el.competency_card.required
        );
        const optionalLength = customArray.filter(
          (el: any) => !el.competency_card.required
        );
        setRequiredWidth(generateHeaderwidth(requiredLength.length));
        setOptionalWidth(generateHeaderwidth(optionalLength.length));
        setDates(
          generateDates(
            earliest,
            latest,
            userContext.timeView.value,
            isLarge ? 13 : 7,
            {
              add_drop_date: semesterContext.selectedSemester.add_drop_date,
              final_assess_date:
                semesterContext.selectedSemester.final_assess_date,
              final_recording_date:
                semesterContext.selectedSemester.competency_recording_deadline,
            }
          )
        );
        setRequiredEvents(
          generateCalendar(requiredLength, earliest, userContext.timeView.value)
        );
        setOptionalEvents(
          generateOptionalCalendar(
            optionalLength,
            earliest,
            requiredLength.length,
            userContext.timeView.value
          )
        );
        setLoading(false);
      })
      .catch((err) => {
        handleJWTError(err);

        // const earliest = semesterContext.selectedSemester.start_date;
        // const latest = semesterContext.selectedSemester.end_date;
        const earliest = moment(semesterContext.selectedSemester.start_date)
          .startOf("month")
          .format("YYYY-MM-DD");
        const latest = moment(semesterContext.selectedSemester.end_date)
          .endOf("month")
          .format("YYYY-MM-DD");
        setCredits("0");
        setDates(
          generateDates(
            earliest,
            latest,
            userContext.timeView.value,
            isLarge ? 13 : 7,
            {
              add_drop_date: semesterContext.selectedSemester.add_drop_date,
              final_assess_date:
                semesterContext.selectedSemester.final_assess_date,
              final_recording_date:
                semesterContext.selectedSemester.competency_recording_deadline,
            }
          )
        );
        setRequiredWidth(generateHeaderwidth(0));
        setOptionalWidth(generateHeaderwidth(0));
        setRequiredCredits(0);
        setOptionalCredits(0);
        setRequiredEvents([]);
        setOptionalEvents([]);
        setLoading(false);
      });
  };
  const redirectDetail = (id: string) => {
    navigate(`/roadmap/detail?rid=${roadmapId}&mid=${id}`);
  };
  const redirectExplore = () => {
    navigate("/explore");
  };

  if (!enrolled) {
    return (
      <CustomRow wrap="nowrap">
        <Col style={{ padding: 0, background: "#000920" }}>
          <StyledTable
            data={[]}
            selectedData={[]}
            dateRange={[
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
            ]}
            timeline={true}
            requiredWidth={requiredWidth}
            optionalWidth={optionalWidth}
            reMapData={() => { }}
            onConfirm={() => { }}
          >
            <div
              style={{
                background:
                  "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
                position: "fixed",
                top: 300,
                left: "40%",
                color: "rgb(255 255 255)",
                fontFamily: "Inter",
                // fontSize: "24px",
                padding: "24px 48px",
                borderRadius: 10,
                // border: "1px solid gray",
                boxShadow: "0 4px 4px rgba(0, 0, 0, 0.17)",
              }}
            >
              Student not enrolled for {semesterContext.selectedSemester.label}
            </div>
          </StyledTable>
        </Col>
      </CustomRow>
    );
  }

  return (
    <>
      {isRemindOpen && (
        <SnackBar
          isOpen={isRemindOpen}
          setOpen={setIsRemindOpen}
          header="New Announcement!"
          message="There is a new announcement."
          type="announcement"
        />
      )}
      <CustomFlex
        $sidebarOpen={userContext.roadmapView.sidebar}
        $isMobile={isMobile}
      >
        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <>
            <ViewSelect />
          </>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          <StyledButton
            onClick={() => {
              redirectRoadmap();
            }}
            style={{ whiteSpace: "nowrap" }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="map"
                />
                Quest
              </>
            ) : (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="map"
                />
              </>
            )}
          </StyledButton>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          <StyledAddButton
            style={{ margin: 0, whiteSpace: "nowrap" }}
            onClick={() => {
              redirectExplore();
            }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="plus-circle"
                />
                Add Milestone
              </>
            ) : (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="plus-circle"
                />
              </>
            )}
          </StyledAddButton>
        </FlexGrow>

        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <StyledText>
            Credits: {credits} (Required: {requiredCredits}, Optional:{" "}
            {optionalCredits})
          </StyledText>
        </FlexGrow>
      </CustomFlex>
      <CustomRow wrap="nowrap">
        <Col style={{ padding: 0 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <StyledTable
              dateRange={dates}
              backgroundColor="#000000"
              // cellBackground="rgb(128, 128, 128)"
              timeline={true}
              requiredWidth={requiredWidth}
              optionalWidth={optionalWidth}
            >
              {requiredEvents.map((event: any, index) => (
                <StyledEvent
                  key={index}
                  onItemClick={() => redirectDetail(event.id)}
                  title={
                    event.competency_card?.title +
                    "\nTarget Date : " +
                    event.endDate
                  }
                  description={event.description}
                  startDate={event.startDate}
                  endDate={event.endDate}
                  left={event.left}
                  top={event.top}
                  height={event.height}
                  backgroundColor={event.backgroundColor || "red"}
                  fontColor={event.fontColor}
                  skills={event.competency_card.skills}
                  credits={event.competency_card.credits}
                  competency_code={event?.competency_card?.competency_code}
                  pendingApproval={event.instructor_approved === false && event.assessment_only === true}
                />
              ))}
              {optionalEvents.map((event: any, index) => (
                <StyledEvent
                  key={index}
                  onItemClick={() => redirectDetail(event.id)}
                  title={
                    event.competency_card?.title +
                    "\nTarget Date : " +
                    event.endDate
                  }
                  description={event.description}
                  startDate={event.startDate}
                  endDate={event.endDate}
                  left={event.left}
                  top={event.top}
                  height={event.height}
                  backgroundColor={event.backgroundColor || "red"}
                  fontColor={event.fontColor}
                  skills={event.competency_card.skills}
                  credits={event.competency_card.credits}
                  competency_code={event.competency_card?.competency_code}
                  pendingApproval={event.instructor_approved === false && event.assessment_only === true}
                />
              ))}
            </StyledTable>
          )}
        </Col>
      </CustomRow>
    </>
  );
}
export default RoadMapTimelinePage;
